import React from 'react';
import { Link } from 'react-router';

import Api from '../../Api';

import AccountOrderStatus from './account_order_status';

var sections = {
  'Account': 'account',
  'Saved Items': 'saved',
  'Orders & Returns': 'orders',
  'Payment information': 'payment',
  'Shipping Information': 'shipping',
  'Invite': 'invite',
  'Log Out': 'logout'
};

export default class Account extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: Api.cache.getUser()
    };
  }

  componentWillMount() {
    Api.userStartListen(this, 'user');
    Api.getUser();
  }

  componentWillUnmount() {
    Api.userStopListen(this);
  }

  render() {
    if (!this.state.user) return (null);
    let currentSection = this.props.location.pathname.replace('/user/account', '').replace(/\//g, '') || 'orders';

    let menu = Object.keys(sections).map((sectionName) => {
      let key = sections[sectionName];

      return (
        <div key={'user-account-menuitem-' + key} className={'menu-item' + (currentSection === key ? ' active' : '')}>
          <Link to={`/user/account/${key}`}>{sectionName}</Link>
        </div>
      );
    });

    return (
      <div className="user-account">
        <div className="menu">{menu}</div>
        <div className="contents">{this.props.children}</div>
      </div>
    );
  }
}

export {
  AccountOrderStatus
};



/** WEBPACK FOOTER **
 ** ./src/views/user/account.js
 **/